// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum ControllerState {
  HasNoController = 0,
  HasUnsizedController = 1,
  HasSizedController = 2,
  HasESPowerStudySizing = 3,
  HasESStartUpSizing = 4,
  HasBothESSizing = 5,
  HasUnsizedES = 6,
}
